import { z } from 'zod';
import { passwordPolicySchema } from './password';
export const PROFILE_NAME_MAX_LENGTH = 100;
const nameComponent = z
    .string()
    .trim()
    .min(1, 'required')
    .max(PROFILE_NAME_MAX_LENGTH, `must be at most ${PROFILE_NAME_MAX_LENGTH} characters`);
const browserHint = (max) => z.string().trim().max(max).optional().catch(undefined);
export const birthdateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be a date (YYYY-MM-DD)')
    .refine((value) => {
    const parsed = new Date(`${value}T00:00:00Z`);
    return (!Number.isNaN(parsed.getTime()) &&
        parsed.toISOString().slice(0, 10) === value &&
        parsed.getTime() <= Date.now() &&
        parsed.getUTCFullYear() >= 1900);
}, 'must be a real date in the past');
export const acceptDocumentsSchema = z.object({
    acceptTerms: z.literal(true, {
        message: 'the Terms of Use must be accepted',
    }),
    acceptPrivacy: z.literal(true, {
        message: 'the Privacy Policy must be accepted',
    }),
});
export const completeProfileRequestSchema = z.object({
    givenName: nameComponent,
    familyName: nameComponent,
    birthdate: birthdateSchema,
    ...acceptDocumentsSchema.shape,
    locale: browserHint(35),
    zoneinfo: browserHint(64),
    password: passwordPolicySchema.optional(),
});
export const profileRequiredResponseSchema = z.object({
    status: z.literal('profile-required'),
});
export const requireBirthdateResponseSchema = z.object({
    status: z.literal('require-birthdate'),
});
export const requireTermsResponseSchema = z.object({
    status: z.literal('require-terms'),
    documents: z.array(z.enum(['terms', 'privacy'])).min(1),
});
export const supplyBirthdateRequestSchema = z.object({
    birthdate: birthdateSchema,
});
//# sourceMappingURL=signup.js.map